/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import {
  Add,
  AutoAwesome,
  FmdBad,
  Task,
  Today,
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Checkbox,
  Chip,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import {
  sortBy,
  uniqBy,
} from 'lodash';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { setSelectedBarnHorse } from '../../../../../../redux/app/actions';
import { getDayOfWeekFromNumber } from '../../../../../../utils/barnBoardHelper';
import {
  blueGrey,
  primary,
  secondary,
} from '../../../../../../utils/brandColors';
import { getColorHexForImportance } from '../../../../../../utils/enumHelper';
import Horse from '../../../../../Horse';
import PlannerReminderCard from '../PlannerReminderCard';
import TaskOverviewCell from '../TaskOverviewCell';

const LOCATION_TRANSITION_WINDOW_IN_DAYS = 8;

const EMPTY_REMINDER_SUGGESTIONS = {};

export const TaskCalendarOverviewHorseRow = React.memo(({
  actionCompleteCallback,
  barnHorse,
  boardSuggestionsKey,
  classes,
  dispatch,
  fullScreen,
  handleCalendarEventItemClick,
  handleOverviewItemClick,
  handleOverviewItemTaskStateChangeClick,
  navigate,
  overviewKey,
  selectedBarnHorses,
  selectedDay,
  selectedLocation,
  setOpenQuickSelectMenu,
  setSelectedBarnHorses,
  setSelectedSlot,
  theme,
  todayTimestamp,
  locations,
  planningMode,
  handleOpenScheduleModal,
  reminderSuggestions = EMPTY_REMINDER_SUGGESTIONS,
  onReminderClick,
}) => {
  const planningDayOfWeek = planningMode && selectedDay && moment(new Date(parseInt(selectedDay, 10))).day();

  const [taskChipSuggestions, setTaskChipSuggestions] = React.useState([]);
  const [horsePopoverBarnHorse, setHorsePopoverBarnHorse] = React.useState(null);
  const normalizedLocations = React.useMemo(
    () => (locations || []).map((horseLocation) => ({
      locationId: horseLocation.location?.id || null,
      startMoment: moment(horseLocation.startDate).startOf('day'),
      endMoment: horseLocation.endDate
        ? moment(horseLocation.endDate).endOf('day')
        : null,
      name: horseLocation.location?.name || 'Unknown Location',
    })),
    [locations],
  );

  const allEventTemplates = useSelector((state) => state.eventTemplate.eventTemplates);
  const mostUsedTaskTypesOfficial = useSelector((state) => state.board.mostUsedTaskTypes);
  const modalConfig = useSelector((state) => state.app.modalConfig);
  const hideSuggestions = !!modalConfig.hideSuggestions;

  const mostUsedTaskTypes = mostUsedTaskTypesOfficial.length >= 2
    ? mostUsedTaskTypesOfficial
    : allEventTemplates.filter((et) => (et.name === 'Flat Ride' || et.name === 'Hand Walk' || et.name === 'Turnout')).map((et) => et.id);

  React.useEffect(() => {
    if (hideSuggestions) { setTaskChipSuggestions([]); return; }
    if (planningMode && selectedDay) {
      const dayOfWeek = `${planningDayOfWeek}`;

      const hasSuggestion = boardSuggestionsKey && boardSuggestionsKey[dayOfWeek]
        && ((boardSuggestionsKey[dayOfWeek].suggestDayTrend
          && boardSuggestionsKey[dayOfWeek].suggestDayTrend.length > 0)
          || (boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend
            && boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend.length > 0)
          || (boardSuggestionsKey[dayOfWeek].suggestRecentTrend
            && boardSuggestionsKey[dayOfWeek].suggestRecentTrend.length > 0));

      const selectedSuggestion = hasSuggestion && {
        daySuggestion: boardSuggestionsKey[dayOfWeek],
        suggestion: boardSuggestionsKey.suggestion,
        dayOfWeek,
        barnHorse,
      }

      let taskSuggestions = []
      const eventTemplatesMap = Object.assign({}, ...(allEventTemplates.map((i) => ({ [i.id]: i }))))
      if (selectedSuggestion) {
        if (selectedSuggestion && selectedSuggestion.daySuggestion) {
          const suggestDayTrend = selectedSuggestion.daySuggestion.suggestDayTrend
            && selectedSuggestion.daySuggestion.suggestDayTrend.length > 0
            && selectedSuggestion.daySuggestion.suggestDayTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
              .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)]);

          let suggestMonthlyTrend = selectedSuggestion.daySuggestion.suggestMonthlyTrend
            && selectedSuggestion.daySuggestion.suggestMonthlyTrend.length > 0
            && selectedSuggestion.daySuggestion.suggestMonthlyTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
              .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)]);
          suggestMonthlyTrend = suggestMonthlyTrend && suggestMonthlyTrend
            .filter((t) => !suggestDayTrend || !suggestDayTrend.find((tt) => tt.id === t.id))

          let suggestRecentTrend = selectedSuggestion.daySuggestion.suggestRecentTrend
            && selectedSuggestion.daySuggestion.suggestRecentTrend.length > 0
            && selectedSuggestion.daySuggestion.suggestRecentTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
              .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
          suggestRecentTrend = suggestRecentTrend && suggestRecentTrend
            .filter((t) => (!suggestDayTrend || !suggestDayTrend.find((tt) => tt.id === t.id))
              && (!suggestMonthlyTrend || !suggestMonthlyTrend.find((tt) => tt.id === t.id)))

          taskSuggestions = [...(suggestDayTrend || []).map((t) => ({
            ...t,
            title: `Questri Suggestion: Frequently Planned on ${getDayOfWeekFromNumber(selectedSuggestion.dayOfWeek)}`,
            suggestion: true,
          })),
          ...(suggestMonthlyTrend || []).map((t) => ({
            ...t,
            title: 'Questri Suggestion: Frequently Used',
            suggestion: true,
          })),
          ...(suggestRecentTrend || []).map((t) => ({
            ...t,
            title: 'Questri Suggestion: Frequently Planned Last 5 Days',
            suggestion: true,
          }))]
        }
      }
      taskSuggestions = [
        ...taskSuggestions,
        ...mostUsedTaskTypes
          .filter((t) => !taskSuggestions.find((ts) => ts.id === t)
            && eventTemplatesMap[t])
          .map((t) => ({
            ...eventTemplatesMap[t],
            title: 'Frequently Used',
            suggestion: false,
          })),
      ].filter((t) => !(overviewKey[selectedDay] || []).find((i) => t.id === i.taskTypeId));
      setTaskChipSuggestions(sortBy(uniqBy(taskSuggestions, 'id'), 'name'))
    }
  }, [selectedDay, planningMode, boardSuggestionsKey, hideSuggestions, allEventTemplates, mostUsedTaskTypesOfficial, overviewKey])

  return (
    <TableRow
      sx={classes.row}
      key={`task-item-${barnHorse.id}`}
      style={{
        borderLeft: `4px solid ${barnHorse.horse.activeNote
          ? getColorHexForImportance(barnHorse.horse.activeNote.importance, theme)
          : 'inherit'}`,
      }}
      onMouseEnter={() => { setHorsePopoverBarnHorse(true); }}
      onMouseLeave={() => { setHorsePopoverBarnHorse(false); }}
    >
      {!fullScreen && (
        <TableCell
          padding="none"
          sx={{
            ...classes.cellStickyNarrow,
            borderBottom: `2px solid ${'var(--primary-unknown)'}`,
          }}
          style={{ '--primary-unknown': primary[500] }}
        >
          <Checkbox
            color="primary"
            onChange={(event) => setSelectedBarnHorses(event.target.checked
              ? [...selectedBarnHorses, barnHorse.pingumTagId]
              : selectedBarnHorses.filter((t) => t !== barnHorse.pingumTagId))}
            checked={selectedBarnHorses.indexOf(barnHorse.pingumTagId) >= 0}
            inputProps={{ 'aria-labelledby': `barn-horse-row-checkbox-${barnHorse.id}` }}
          />
        </TableCell>
      )}
      <TableCell
        sx={[classes.cellSticky, {
          minWidth: fullScreen && '90px !important',
          maxWidth: fullScreen && '90px !important',
          width: fullScreen && '90px !important',
          left: fullScreen && '0 !important',
          borderBottom: `2px solid ${'var(--primary-unknown)'}`,
        }, horsePopoverBarnHorse
          ? { backgroundColor: `${blueGrey[50]} !important` }
          : { backgroundColor: null }]}
        style={{ '--primary-unknown': primary[500] }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Horse
            size={36}
            horse={barnHorse.horse}
            hideShowName
            onClick={() => { dispatch(setSelectedBarnHorse(barnHorse)); }}
            clickable
            flexDirection={!fullScreen
              ? 'row'
              : 'column'}
            textWidth={fullScreen
              ? 90
              : 146}
            showActiveNoteIndicator
          />
        </Box>
      </TableCell>
      {
        Object.keys(overviewKey)
          .filter((day) => !selectedDay || day === selectedDay).map((day) => {
            const dayAsDate = new Date(parseInt(day, 10));
            const dayOfWeek = moment(dayAsDate).day();
            const dayReminders = reminderSuggestions[day] || [];
            const reminderTemplateIds = new Set(dayReminders.map((suggestion) => String(suggestion.template.id)));
            const dayTaskChipSuggestions = taskChipSuggestions.filter((taskType) => !reminderTemplateIds.has(String(taskType.id)));

            const hasSuggestion = boardSuggestionsKey && boardSuggestionsKey[dayOfWeek]
              && ((boardSuggestionsKey[dayOfWeek].suggestDayTrend
                && boardSuggestionsKey[dayOfWeek].suggestDayTrend.length > 0)
                || (boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend
                  && boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend.length > 0)
                || (boardSuggestionsKey[dayOfWeek].suggestRecentTrend
                  && boardSuggestionsKey[dayOfWeek].suggestRecentTrend.length > 0));

            const dayMoment = moment(dayAsDate).startOf('day');

            const locationsForDay = normalizedLocations.filter((horseLocation) => dayMoment.isSameOrAfter(horseLocation.startMoment)
              && (!horseLocation.endMoment || dayMoment.isSameOrBefore(horseLocation.endMoment)));
            const uniqueLocationsForDay = uniqBy(locationsForDay, 'locationId');
            const isPresentInLocationForDay = uniqueLocationsForDay
              .filter((l) => l.locationId === selectedLocation.id).length > 0;

            const isSoonToArriveAtLocation = !isPresentInLocationForDay && normalizedLocations.some((horseLocation) => dayMoment.isBefore(horseLocation.startMoment)
              && horseLocation.startMoment.diff(dayMoment, 'days')
              <= LOCATION_TRANSITION_WINDOW_IN_DAYS && horseLocation.locationId === selectedLocation.id);

            const hasRecentlyLeftLocation = !isPresentInLocationForDay && normalizedLocations.some((horseLocation) => {
              if (!horseLocation.endMoment) {
                return false;
              }
              if (!dayMoment.isAfter(horseLocation.endMoment)) {
                return false;
              }
              return dayMoment.diff(horseLocation.endMoment, 'days')
                <= LOCATION_TRANSITION_WINDOW_IN_DAYS && horseLocation.locationId === selectedLocation.id;
            });

            // const locationIdentifiersForDay = locationsForDay.map((horseLocation, index) => {
            //   if (horseLocation.locationId) {
            //     return horseLocation.locationId;
            //   }
            //   const startKey = horseLocation.startMoment.unix();
            //   const endKey = horseLocation.endMoment
            //     ? horseLocation.endMoment.unix()
            //     : 'open';
            //   return `unknown-${startKey}-${endKey}-${index}`;
            // });

            const clickSelectTask = (calendarEventTab = false) => {
              const updatedSelectedBarnHorses = [...selectedBarnHorses
                .filter((t) => t !== barnHorse.pingumTagId), barnHorse.pingumTagId];
              setSelectedBarnHorses(updatedSelectedBarnHorses);

              const selectedSlot = {
                start: dayAsDate,
                end: new Date(dayAsDate.getTime() + 86400000), // mimicks an all day event
                barnHorses: updatedSelectedBarnHorses,
                callback: actionCompleteCallback,
                isHorseTask: true,
                calendarEventTab,
                dayOfWeek,
                selectedSuggestion: hasSuggestion && {
                  daySuggestion: boardSuggestionsKey[dayOfWeek],
                  suggestion: boardSuggestionsKey.suggestion,
                  dayOfWeek,
                  barnHorse,
                },
              };
              setSelectedSlot(selectedSlot);
              setOpenQuickSelectMenu(true);
            }
            return (
              <TableCell
                sx={
                  [day.toString() === todayTimestamp.toString()
                    ? classes.cellHighlight
                    : (day < todayTimestamp
                      ? classes.cellPast
                      : classes.cell), {
                    minWidth: fullScreen && 'auto !important',
                    maxWidth: fullScreen && '0 !important',
                    position: 'relative',
                    borderWidth: '2px',
                    borderBottom: `2px solid ${'var(--primary-unknown)'}`,
                    '&:hover': { background: blueGrey[50] },
                  }]
                }
                key={`table-row-${barnHorse.id}-${day}`}
                onClick={() => clickSelectTask(false)}
                style={{ '--primary-unknown': primary[500] }}
              >
                {
                  overviewKey[day] && overviewKey[day].length > 0 && (
                    <Box>
                      <TaskOverviewCell
                        items={overviewKey[day]}
                        onClick={handleOverviewItemClick}
                        onClickCalendarEvent={handleCalendarEventItemClick}
                        onTaskStateChange={handleOverviewItemTaskStateChangeClick}
                        today={day.toString() === todayTimestamp.toString()}
                        navigate={navigate}
                        inPast={day < todayTimestamp}
                        overrideShowAll={((!!planningDayOfWeek && planningDayOfWeek === dayOfWeek) || (planningDayOfWeek === 0 && dayOfWeek === 0))}
                        // showTime={((!!planningDayOfWeek && planningDayOfWeek === dayOfWeek) || (planningDayOfWeek === 0 && dayOfWeek === 0))}
                        showTime
                      />
                    </Box>
                  )
                }
                {dayReminders.length > 0 && (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.75,
                      p: 0.75,
                    }}
                  >
                    {dayReminders.map((suggestion) => (
                      <PlannerReminderCard key={suggestion.id} suggestion={suggestion} onClick={onReminderClick} />
                    ))}
                  </Box>
                )}
                <Box
                  sx={{
                    height: (overviewKey[day] && overviewKey[day].length <= 2 && !hasRecentlyLeftLocation && !isSoonToArriveAtLocation)
                      ? '33px'
                      : 0,
                  }}
                />
                {
                  !hideSuggestions && ((planningDayOfWeek && planningDayOfWeek === dayOfWeek) || (planningDayOfWeek === 0 && dayOfWeek === 0))
                  && (
                    <Box
                      sx={{ display: 'flex' }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          ml: 4,
                        }}
                      >
                        <Box
                          sx={[{
                            display: 'flex',
                            gap: 1,
                            p: 1,
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            borderTopLeftRadius: 12,
                            borderTop: `1px dashed ${'var(--secondary-unknown)'}`,
                            borderLeft: `1px dashed ${'var(--secondary-unknown)'}`,
                          }, overviewKey[day].length > 0
                            ? { opacity: '50%' }
                            : { opacity: null }]}
                          style={{ '--secondary-unknown': secondary[500] }}
                        >
                          {
                            dayTaskChipSuggestions.map((taskType) => {
                              const clickTask = (e) => {
                                e.stopPropagation();
                                e.preventDefault();

                                const updatedSelectedBarnHorses = [...selectedBarnHorses
                                  .filter((t) => t !== barnHorse.pingumTagId), barnHorse.pingumTagId];
                                const selectedSlot = {
                                  start: dayAsDate,
                                  end: new Date(dayAsDate.getTime() + 86400000), // mimicks an all day event
                                  barnHorses: updatedSelectedBarnHorses,
                                  callback: actionCompleteCallback,
                                  isHorseTask: true,
                                  dayOfWeek,
                                  selectedSuggestion: hasSuggestion && {
                                    daySuggestion: boardSuggestionsKey[dayOfWeek],
                                    suggestion: boardSuggestionsKey.suggestion,
                                    dayOfWeek,
                                    barnHorse,
                                  },
                                  taskType,
                                }
                                handleOpenScheduleModal(taskType, false, selectedSlot)
                              }
                              return (

                                <Chip
                                  key={`task-chip-${taskType.id}`}
                                  sx={{
                                    border: '1px solid #CECECE',
                                    borderRadius: '6px',
                                    borderLeft: `6px solid ${(taskType.eventDataDefaultValues && taskType.eventDataDefaultValues.calendarDisplayColor) || primary[500]}`,
                                  }}
                                  size="small"
                                  variant="outlined"
                                  label={taskType.name}
                                  deleteIcon={taskType.suggestion
                                    ? (
                                      <Tooltip
                                        disableInteractive
                                        title={taskType.title}
                                      >
                                        <AutoAwesome sx={{ color: '#FF6600 !important' }} />
                                      </Tooltip>
                                    )
                                    : undefined}
                                  onClick={clickTask}
                                  onDelete={(taskType.suggestion && clickTask) || undefined}
                                />
                              )
                            })
                          }

                          <Tooltip title="Select from list of tasks" placement="top" disableInteractive>
                            <Chip
                              sx={{
                                border: '1px solid #CECECE',
                                borderRadius: '6px',
                              }}
                              icon={<Task color="secondary" />}
                              size="small"
                              label={dayTaskChipSuggestions.length > 0
                                ? 'Tasks'
                                : 'Select Task'}
                              variant="outlined"
                              deleteIcon={<Add color="secondary" />}
                              onClick={(e) => { e.stopPropagation(); clickSelectTask(false); }}
                              onDelete={(e) => { e.stopPropagation(); clickSelectTask(false); }}
                            />
                          </Tooltip>
                          <Tooltip title="Select from list of Calendars" placement="top" disableInteractive>
                            <Chip
                              sx={{
                                border: '1px solid #CECECE',
                                borderRadius: '6px',
                              }}
                              icon={<Today color="secondary" />}
                              size="small"
                              label="Calendars"
                              variant="outlined"
                              deleteIcon={<Add color="secondary" />}
                              onClick={(e) => { e.stopPropagation(); clickSelectTask(true); }}
                              onDelete={(e) => { e.stopPropagation(); clickSelectTask(true); }}
                            />
                          </Tooltip>

                          {
                            uniqueLocationsForDay.length > 1 && (
                              <Tooltip title={`This horse is located in more than one location on this day: ${uniqueLocationsForDay.map((l) => l.name).join(', ')}`} placement="top" disableInteractive>
                                <FmdBad
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(setSelectedBarnHorse(barnHorse));
                                  }}
                                  color="secondary"
                                  sx={{
                                    fontSize: '1.25rem !important',
                                    padding: '2px',
                                  }}
                                />
                              </Tooltip>
                            )
                          }
                        </Box>
                      </Box>
                    </Box>
                  )
                }

                {
                  isSoonToArriveAtLocation && (
                    <Alert
                      sx={{
                        borderRadius: 0,
                        width: '100%',
                        mt: 2,
                        py: 0,
                      }}
                      severity="info"
                      variant="outlined"
                    >
                      Arriving soon to {selectedLocation.name}
                    </Alert>
                  )
                }
                {
                  hasRecentlyLeftLocation && (
                    <Alert
                      sx={{
                        borderRadius: 0,
                        width: '100%',
                        mt: 2,
                        py: 0,
                      }}
                      severity="info"
                      variant="filled"
                    >
                      Recently left {selectedLocation.name}
                    </Alert>
                  )
                }
              </TableCell>
            );
          })
      }
    </TableRow>
  );
});
